import { useMemo } from "react";

import CountryService from "app/services/CountryService";

import { useDurationContext } from "../../../contexts/DurationContext";
import { useActivationSet } from "../../../hooks/useActivationSet";

export const useMetricsSubtitleFilters = () => {
    const duration = useDurationContext();
    const { activationSet } = useActivationSet();

    return useMemo(
        () => [
            {
                filter: "date" as const,
                value: {
                    from: duration.forAPI.iso.from,
                    to: duration.forAPI.iso.to,
                },
            },
            ...(activationSet?.country != null
                ? [
                      {
                          filter: "country" as const,
                          countryCode: activationSet.country,
                          value: CountryService.getCountryById(activationSet.country)?.text ?? "",
                      },
                  ]
                : []),
        ],
        [activationSet?.country, duration.forAPI.iso.from, duration.forAPI.iso.to],
    );
};
